export const T = {
  en_GB: {
    settings: "Settings",
    singleSignOn: "Single Sign-On (SSO)",
    pageDescription: "Configure SSO to allow users to sign in with your identity provider",
    featureNotEnabled: "Feature not enabled",
    featureNotEnabledDescription:
      "SSO is not enabled for your organization. Please contact your administrator to enable this feature.",
    noPermission: "You do not have permission to manage SSO settings.",
  },
  nb_NO: {
    settings: "Innstillinger",
    singleSignOn: "Enkel innlogging (SSO)",
    pageDescription: "Konfigurer SSO for å la brukere logge inn med din identitetsleverandør",
    featureNotEnabled: "Funksjon ikke aktivert",
    featureNotEnabledDescription:
      "SSO er ikke aktivert for organisasjonen din. Kontakt administratoren for å aktivere denne funksjonen.",
    noPermission: "Du har ikke tillatelse til å administrere SSO-innstillinger.",
  },
} as const;
